const { en: common } = require("../../common");

module.exports = {
	...common,
	"free-trial": require("./free-trial.json"),
};
